<span
  *ngIf="displayLabel"
  class="status-chip"
  [ngClass]="[chipClass, isCompact ? 'chip--compact' : '']"
  [style.background-color]="bg"
  [style.color]="color"
>
  <i *ngIf="displayIcon" [class]="displayIcon"></i>
  {{ displayLabel }}
</span>
